const SIMPLE = 'simple'
const MULTIPLE = 'multiple'

export {
    SIMPLE,
    MULTIPLE,
}